import CartaId from '../../entities/CartaId';
import { RuleOperation } from '../../enums/POR/RuleOperation';
import UpdatePortOpeningRequestRuleOnPrem from './UpdatePortOpeningOnPremRule';

export default class UpdatePortOpeningRequestOnPrem {

	portOpeningRules!: UpdatePortOpeningRequestRuleOnPrem[];

	contactId!: string;

	emergency!: boolean;

	firewall!: string; //Firewall

	cartaId!: CartaId[];

	businessJustification!: string;

	comments!: string;

	customerCoordination!: boolean;

	approverId!: string;

	approverEmail!: string;

	appEndorserId!: string;

	firewallEnvironment!: string;

	siteCoordination!: boolean;

	trackerID!: number;

	operation?: RuleOperation;

	updateReason?: string;

	constructor(obj: any) {
		Object.assign(this, obj);
	}
}